import React, { useState } from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-software.png'
import software from '../../assets/images/software.png'

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import PricingTwo from "../../components/pricingTwo";

import { featureData, featureTwo } from "../../data/data";

import { FiArrowRight, MdOutlineCheckCircle, FaApple, RiGooglePlayLine } from '../../assets/icons/icons'


export default function IndexSoftware(){
    let [ activeIndex, setActiveIndex ] = useState(1)
    return(
        <>
        <Navbar navLight ={true}/>
        <section className="bg-half-170 d-table w-100 bg-primary" style={{backgroundImage:`url(${bg1})`}}>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="heading-title text-center">
                            <h4 className="heading fw-bold text-white title-dark">Powerfull & Modern <br/> landing for your software</h4>
                            <p className="para-desc mx-auto text-white-50">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="mt-4 pt-2">
                                <Link to="3" className="btn btn-light m-1">Documentation</Link>
                                <Link to="3" className="btn btn-outline-light-alt m-1">Get Started <FiArrowRight className="fea icon-sm"/></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section pb-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="features-absolute">
                            <div className="row">
                                {featureData.map((item, index) =>{
                                    let Icon = item.icon
                                    return(
                                    <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                                        <div className="card border-0 text-center features feature-primary core-feature shadow rounded p-4">
                                            <div className="icon text-center mx-auto rounded-md">
                                                <h3 className="mb-0"><Icon/></h3>
                                            </div>
                                            <div className="card-body p-0 mt-4">
                                                <h5>{item.title}</h5>
                                                <p className="text-muted mb-0">{item.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                })}

                                <div className="col-12 mt-4 pt-2 text-center">
                                    <Link to="#" className="text-primary h6">Explore features <FiArrowRight className="fea icon-sm"/></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Quickstart</h6>
                            <h4 className="title mb-4">Awesome isn't it? Let's dive in!</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 col-mg-10 mt-4 pt-2">
                        <div className="bg-dark bg-white-dark p-4 rounded shadow">
                            <div className="row">
                                <div className="col-lg-12">
                                    <ul className="nav nav-pills nav-justified flex-column flex-sm-row rounded bg-soft-light">
                                        <li className="nav-item">
                                            <Link className={`${activeIndex === 1 ? 'active' : ''} nav-link nav-link-alt rounded`} to="#" onClick={() =>setActiveIndex(1)}>
                                                <div className="text-center">
                                                    <h5 className="title fw-normal mb-0 text-light title-dark">npm</h5>
                                                </div>
                                            </Link>
                                        </li>
                                        
                                        <li className="nav-item">
                                            <Link className={`${activeIndex === 2 ? 'active' : ''} nav-link nav-link-alt rounded`} to="#" onClick={() =>setActiveIndex(2)}>
                                                <div className="text-center">
                                                    <h5 className="title fw-normal mb-0 text-light title-dark">nuget</h5>
                                                </div>
                                            </Link>
                                        </li>
                                        
                                        <li className="nav-item">
                                            <Link className={`${activeIndex === 3 ? 'active' : ''} nav-link nav-link-alt rounded`} to="#" onClick={() =>setActiveIndex(3)}>
                                                <div className="text-center">
                                                    <h5 className="title fw-normal mb-0 text-light title-dark">spm</h5>
                                                </div>
                                            </Link>
                                        </li>
                                        
                                        <li className="nav-item">
                                            <Link className={`${activeIndex === 4 ? 'active' : ''} nav-link nav-link-alt rounded`} to="#" onClick={() =>setActiveIndex(4)}>
                                                <div className="text-center">
                                                    <h5 className="title fw-normal mb-0 text-light title-dark">github</h5>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="tab-content">
                                        {activeIndex === 1 ?
                                            <div className="tab-pane fade show active">
                                                <p className="text-muted fw-bold mb-0"><span className="text-success">$</span> npm install <span className="text-success">-g</span> claps.js</p>
                                            </div> : ''
                                        }
                                        {activeIndex === 2 ? 
                                            <div className="tab-pane fade show active">
                                                <p className="text-muted fw-bold mb-0">coming soon ...</p>                       
                                            </div> : ''
                                        }
                                        {activeIndex === 3 ? 
                                            <div className="tab-pane fade show active">
                                                <p className="text-muted fw-bold mb-0">coming soon ...</p>                       
                                            </div> : ''
                                        }
                                        {activeIndex === 4 ? 
                                            <div className="tab-pane fade show active">
                                                <p className="text-muted fw-bold mb-0">coming soon ...</p>                       
                                            </div> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ul className="list-unstyled text-muted mb-0 mt-3">
                            <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-success h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Organize your data</li>
                            <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-success h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Work with any team</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <img src={software} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-lg-7 col-md-6 mt-4 mt-am-0 pt-2 pt-sm-0">
                        <div className="ms-lg-5">
                            <div className="section-title">
                                <h6 className="text-primary">Analytics</h6>
                                <h4 className="title mb-4">Organize your work <br/> anywhere</h4>
                                <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            
                                <ul className="list-unstyled text-muted mt-3">
                                    <li className="mb-0 ms-0"><span className="text-primary h5 me-2 ms-0"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                                    <li className="mb-0 ms-0"><span className="text-primary h5 me-2 ms-0"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                                    <li className="mb-0 ms-0"><span className="text-primary h5 me-2 ms-0"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                                </ul>

                                <div className="mt-4">
                                    <Link to="#" className="btn btn-soft-primary">Try for free <FiArrowRight className="fea icon-sm"/></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Features</h6>
                            <h4 className="title mb-4">Explore about our awesome features</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10 mt-4">
                        <ul className="list-unstyled text-center mb-0">
                            {featureTwo.map((item,index) =>{
                                let Icon = item.icon
                                return(
                                    <li className="list-inline-item m-2" key={index}>
                                        <div className="d-flex key-feature feature-primary align-items-center rounded-lg shadow py-2 px-3">
                                            <div className="icon text-center rounded-circle me-3">
                                                <Icon className="fea icon-ex-md"/>
                                            </div>
                                            <h5 className="mb-0 title">{item.title}</h5>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section className="section bg-light">
            <div className="container">
                <PricingTwo bgColor="card pricing border-0 p-4 rounded-md shadow bg-dark bg-white-dark"/>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title">
                            <h4 className="title mb-4">Get the App now !</h4>
                            <p className="text-muted para-desc mx-auto">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-pills btn-primary m-1"><FaApple/> App Store</Link>
                                <Link to="#" className="btn btn-pills btn-soft-primary m-1"><RiGooglePlayLine/> Play Store</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer/>
        <ScrollTop/>
        </>
    )
}